import { render } from "./InvoiceDashboard.vue?vue&type=template&id=336f7321&scoped=true"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js"

import "./InvoiceDashboard.vue?vue&type=style&index=0&id=336f7321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336f7321"]])

export default __exports__